export default "__VITE_ASSET__CHwoztt7__"